<ion-menu contentId="main-content" style="--width: 280px">
	<app-drawer />
</ion-menu>

<ion-tabs id="main-content">
	@if (!whiteLabelService.isV2Skin() || isCompactTabBarExpanded()) {
		<ion-tab-bar
			slot="bottom"
			class="h-15 pb-[env(safe-area-inset-bottom)] bg-(--ion-color-dark)"
			[class.exchange-compact-tab-bar]="whiteLabelService.isV2Skin()"
			[class.v3-tab-bar]="whiteLabelService.isV3Skin()">
			<ion-tab-button tab="home" href="/home">
				<ion-icon [name]="whiteLabelService.isV3Skin() ? v3HomeIconName : 'home-outline'"></ion-icon>
				<ion-label>{{ 'Home' | translate }}</ion-label>
			</ion-tab-button>

			<ion-tab-button tab="my-markets" href="/my-markets">
				<ion-icon [name]="whiteLabelService.isV3Skin() ? 'list' : 'star'"></ion-icon>
				<ion-label>{{ 'My Markets' | translate }}</ion-label>
			</ion-tab-button>

			<ion-tab-button (click)="openAsianCasino()" (keydown.enter)="openAsianCasino()">
				<ion-icon [name]="whiteLabelService.isV3Skin() ? 'game-controller' : 'game-controller-outline'"></ion-icon>
				<ion-label>{{ 'Asian Casino' | translate }}</ion-label>
			</ion-tab-button>

			<ion-tab-button tab="my-bets" href="/my-bets">
				<ion-icon [name]="whiteLabelService.isV3Skin() ? v3MyBetsIconName : 'document-text-outline'"></ion-icon>
				<ion-label>{{ 'My Bets' | translate }}</ion-label>
			</ion-tab-button>

			@if (whiteLabelService.isV2Skin()) {
				<button
					type="button"
					class="exchange-compact-tab-bar__collapse"
					aria-label="Hide menu"
					[attr.aria-expanded]="true"
					(click)="toggleCompactTabBar()">
					<ion-icon name="chevron-down-outline"></ion-icon>
				</button>
			}
		</ion-tab-bar>
	}
</ion-tabs>

@if (whiteLabelService.isV2Skin() && !isCompactTabBarExpanded()) {
	<button type="button" class="exchange-compact-menu-peek" aria-label="Open menu" [attr.aria-expanded]="false" (click)="toggleCompactTabBar()">
		<ion-icon name="chevron-up-outline"></ion-icon>
		<span>{{ 'Menu' | translate }}</span>
	</button>
}
